<template>
  <div class="header">
    <div class="nav-topbar">
      <!-- 装饰背景块 -->
      <div class="decor-blocks">
        <div class="block b1"></div>
        <div class="block b2"></div>
        <div class="block b3"></div>
        <div class="block b4"></div>
        <div class="block b5"></div>
        <div class="block b6"></div>
      </div>
      <div class="container">
        <div class="topbar-menu">
          <a href="javascript:;" @click="goToIndex">手办商城</a>
          <a href="javascript:;" @click="goToPresale">预售专区</a> 
        </div>
        <div class="topbar-user">
          <a href="javascript:;" @click="login" v-if="!hasLogin">登录</a>
          <span v-if="hasLogin">{{displayName}}   </span>
          
          <a href="/#/personal-space" v-if="hasLogin">个人空间</a>
          <a href="javascript:;" class="my-cart" @click="goToCart">
            <i class="el-icon-shopping-cart-2"></i>
            <span>购物车</span>
            <span class="cart-count-text">({{ cartCount }})</span>
          </a>
          <a href="javascript:;" @click="logout" v-if="hasLogin">退出</a>
        </div>
      </div>
    </div>
    <div class="nav-header">
      <div class="container">
        <div class="header-logo">
          <a href="/#/index"></a>
        </div>
        
        <div class="header-search">
          <div class="wrapper" style="border-radius: 20px">
            <input 
              type="text"  
              v-model="keyword" 
              name="keyword" 
              :placeholder="placeholderText"
              @keyup.enter="doSearch()"
            >
            <a href="javascript:;" @click="doSearch()">
              <i class="el-icon-search"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getCartByUserId, getProductsBySort } from '@/apis/ProductCard'

  // 导航头部组件：网站顶部导航，包含登录/注册、购物车、搜索功能
  export default{
    name:'nav-header',
    data(){
      return {
        phoneList: [],
        keyword:"",
        placeholderText: "请输入产品关键字",
        latestProducts: [],
        placeholderIndex: 0,
        placeholderTimer: null,
        cartCount: 0 // 购物车数量，默认为0
      }
    },
    computed:{
      displayName(){
        const nickname = localStorage.getItem('nickname');
        const username = localStorage.getItem('username');
        return nickname || username || '';
      },
      hasLogin(){
        return !!this.displayName;
      }
    },
    watch: {
      '$route.query.keyword': {
        handler(newVal) {
          if (newVal) {
            this.keyword = newVal;
          } else {
            this.keyword = '';
          }
        },
        immediate: true
      }
    },
    
    mounted(){
      // 获取最新上架的前3个商品作为搜索框占位符
      this.getLatestProducts();
      // 组件挂载时获取购物车数量
      this.getCartCount();
      // 监听全局事件，当购物车更新时重新获取数量
      this.$root.$on('cart-updated', () => {
        this.getCartCount();
      });
    },
    beforeDestroy() {
      // 销毁组件前清除定时器
      if (this.placeholderTimer) {
        clearInterval(this.placeholderTimer);
      }
    },
  methods: {
      goToIndex(){
        this.$router.push('/index');
      },
      goToPresale(){
        this.$router.push('/presale');
      },
      login(){
        this.$router.push('/login');
      },
      getProductList(){
      },
      // 获取购物车数量
      getCartCount(){
        const userId = localStorage.getItem('userId');
        if (!userId) {
          this.cartCount = 0;
          return;
        }
        
        getCartByUserId(parseInt(userId)).then(res => {
          if (res.code === 200 && res.data) {
            // 计算购物车商品总数
            const totalCount = res.data.reduce((sum, item) => sum + item.quantity, 0);
            this.cartCount = totalCount;
          } else {
            this.cartCount = 0;
          }
        }).catch(err => {
          console.error('获取购物车失败:', err);
          this.cartCount = 0;
        });
      },
      // 获取最新上架的前3个商品
      getLatestProducts() {
        getProductsBySort('created_time', 'desc', 1, 3).then(res => {
          if (res.code === 200 && res.data && res.data.records) {
            this.latestProducts = res.data.records;
            if (this.latestProducts.length > 0) {
              this.startPlaceholderRotation();
            }
          }
        }).catch(err => {
          console.error('获取最新商品失败:', err);
        });
      },
      // 开始占位符文字轮播
      startPlaceholderRotation() {
        // 初始设置第一个
        this.updatePlaceholder();
        // 每3秒切换一次
        this.placeholderTimer = setInterval(() => {
          this.placeholderIndex = (this.placeholderIndex + 1) % this.latestProducts.length;
          this.updatePlaceholder();
        }, 3000);
      },
      updatePlaceholder() {
        const product = this.latestProducts[this.placeholderIndex];
        if (product) {
          this.placeholderText = product.productName;
        }
      },
      logout(){
          // 清除localStorage中的用户数据
          localStorage.removeItem('token');
          localStorage.removeItem('userId');
          localStorage.removeItem('username');
          localStorage.removeItem('nickname');
          
          // 清除Vuex中的状态（如果有的话）
          // this.$store.dispatch('saveUserName','');
          
          // 清空购物车数量
          this.cartCount = 0;
          
          // 显示退出成功消息
          this.$message.success('退出成功');
          
          // 跳转到登录页面
          this.$router.push('/login');
      },
      doSearch(){
          const searchKeyword = this.keyword || this.placeholderText || '';
          this.$router.push({
            path: '/products',
            query: { keyword: searchKeyword }
          }).catch(err => {
            // 如果已经在搜索页，只需更新参数
            if (err.name !== 'NavigationDuplicated') {
              console.error(err);
            }
          });
      },
      goToCart(){
        this.$router.push('/cart');
      }
    }
  }
</script>
<style lang="scss">
  @import '@/assets/scss/base.scss';
  @import '@/assets/scss/mixin.scss';
  @import '@/assets/scss/config.scss';
  .header{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: #ffffff;
    box-shadow: 0 10px 26px rgba(108, 123, 255, 0.12);
    &::before{
      content:'';
      position:absolute;
      left:0;
      right:0;
      top:0;
      height:3px;
      background: linear-gradient(90deg, #6c7bff 0%, #00d4ff 35%, #ff7bd5 70%, #ffb347 100%);
    }
    .nav-topbar{
      height:39px;
      line-height:39px;
      background: linear-gradient(90deg, #2a2f4f 0%, #2b2a6b 50%, #3a2b6b 100%);
      color:#dfe5ff;
      position: relative;
      overflow: hidden;
      .decor-blocks {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        .block {
          position: absolute;
          opacity: 0.3;
          &.b1 {
            left: -30px;
            top: -20px;
            width: 80px;
            height: 80px;
            transform: rotate(-35deg);
            background: repeating-linear-gradient(-45deg, #00d4ff 0, #00d4ff 4px, transparent 4px, transparent 8px);
          }
          &.b2 {
            left: 15%;
            top: 10px;
            width: 40px;
            height: 40px;
            transform: rotate(45deg);
            background: repeating-linear-gradient(-45deg, #ff7bd5 0, #ff7bd5 4px, transparent 4px, transparent 8px);
            opacity: 0.2;
          }
          &.b3 {
            left: 40%;
            top: -15px;
            width: 50px;
            height: 50px;
            transform: rotate(-25deg);
            background: repeating-linear-gradient(-45deg, #00d4ff 0, #00d4ff 3px, transparent 3px, transparent 6px);
            opacity: 0.15;
          }
          &.b4 {
            left: 65%;
            top: 5px;
            width: 35px;
            height: 35px;
            transform: rotate(35deg);
            background: repeating-linear-gradient(-45deg, #6c7bff 0, #6c7bff 4px, transparent 4px, transparent 8px);
            opacity: 0.1;
          }
          &.b5 {
            right: 12%;
            top: -10px;
            width: 60px;
            height: 60px;
            transform: rotate(-40deg);
            background: repeating-linear-gradient(-45deg, #6c7bff 0, #6c7bff 4px, transparent 4px, transparent 8px);
          }
          &.b6 {
            right: -30px;
            top: -20px;
            width: 100px;
            height: 100px;
            transform: rotate(30deg);
            background: repeating-linear-gradient(-45deg, #ff7bd5 0, #ff7bd5 5px, transparent 5px, transparent 10px);
            opacity: 0.4;
          }
        }
      }
      .container{
        @include flex();
        a{
          display:inline-block;
          color:#dfe5ff;
          margin-right:17px;
          &:hover{
            color:#00d4ff;
          }
        }
        .my-cart{
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          width: auto;
          padding: 0 16px;
          min-width: 100px;
          background: linear-gradient(135deg, #6c7bff 0%, #8c7bff 50%, #ff7bd5 100%);
          text-align: center;
          color: #ffffff;
          margin-right: 0;
          border-radius: 12px;
          transition: all 0.2s ease;
          border: 1px solid rgba(255, 255, 255, 0.2);
          position: relative;
          &:hover{
            box-shadow: 0 6px 16px rgba(108, 123, 255, 0.4);
            transform: translateY(-1px);
          }
          i {
            font-size: 18px;
            color: #ffffff;
          }
          span {
            font-size: 14px;
            font-weight: 500;
          }
          .cart-count-text {
            font-size: 13px;
            font-weight: 600;
            color: #ffffff;
            opacity: 0.9;
            margin-left: 2px;
          }
        }
      }
    }
    .nav-header{
      .container{
        position:relative;
        height:60px;
        @include flex();
        .header-menu{
          display:inline-block;
          width:643px;
          padding-left:209px;
          .item-menu{
            display:inline-block;
            color:#333333;
            font-weight:bold;
            font-size:16px;
            line-height:112px;
            margin-right:20px;
            span{
              cursor:pointer;
            }
            &:hover{
              color:$colorA;
              .children{
                height:220px;
                opacity:1;
              }
            }
            .children{
              position:absolute;
              top:112px;
              left:0;
              width:1226px;
              height:0;
              opacity:0;
              overflow:hidden;
              border-top:1px solid #E5E5E5;
              box-shadow:0px 7px 6px 0px rgba(0, 0, 0, 0.11);
              z-index: 10;
              transition:all .5s;
              background-color: #ffffff;
              .product{
                position:relative;
                float:left;
                width:16.6%;
                height:220px;
                font-size:12px;
                line-height:12px;
                text-align: center;
                a{
                  display:inline-block;
                }
                img{
                  width:auto;
                  height:111px;
                  margin-top:26px;
                }
                .pro-img{
                  height:137px;
                }
                .pro-name{
                  font-weight:bold;
                  margin-top:19px;
                  margin-bottom:8px;
                  color:$colorB;
                }
                .pro-price{
                  color:$colorA;
                }
                &:before{
                  content:' ';
                  position:absolute;
                  top:28px;
                  right:0;
                  border-left:1px solid $colorF;
                  height:100px;
                  width:1px;
                }
                &:last-child:before{
                  display:none;
                }
              }
            }
          }
        }
        .header-search {
          .wrapper {
            position: relative;
            display: flex;
            align-items: center;
            width: 319px;
            height: 50px;
            border: 1px solid #e0e0e0;
            background: #fff;
            transition: all 0.3s;
            border-radius: 20px;
            
            &:hover, &.active {
              border-color: #6c7bff;
              box-shadow: 0 0 8px rgba(108, 123, 255, 0.15);
            }

            input {
              border: none;
              box-sizing: border-box;
              width: 264px;
              height: 50px;
              padding-left: 20px;
              font-size: 14px;
              color: #333;
              outline: none;
              background: transparent;
              
              &::placeholder {
                color: #b0b0b0;
                opacity: 0.8;
                font-style: italic;
              }
            }

            a {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 55px;
              height: 50px;
              transition: all 0.3s;
              text-decoration: none; // 移除下划线
              
              .el-icon-search {
                font-size: 20px;
                color: #666;
                font-weight: bold;
              }
              
              &:hover {
                .el-icon-search {
                  color: #6c7bff;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
